@let _navItems = navItems();
@let _hasNav = _navItems.length > 0;

@if (showLoader()) {
  <ui-cms-skeleton></ui-cms-skeleton>
}

@if (config(); as config) {
  <div class="wrapper-plp" [class.has-nav]="_hasNav">
    @if (_hasNav) {
      <ui-category-side-menu
        [navItems]="_navItems"
        [selectedItemId]="selectedItemId()"
      ></ui-category-side-menu>
    }

    <div class="wrapper-content">
      <ui-cms
        (hasContent)="onLoadResult($event)"
        (pageLoaded)="onPageLoaded($event)"
        [config]="config"
        [notFoundPageEnabled]="true"
        [hidden]="!hasContent()"
        [errorFallbackEnabled]="true"
      ></ui-cms>
    </div>
  </div>
}
